import ProduitsList from './ProduitsList'
export default ProduitsList
